// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:00:49

export default {
  "id": "dirty-money-the-rich-get-rich",
  "slug": "dirty-money-the-rich-get-rich",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8673fbf6ca0443d594e1930c36d20235-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8673fbf6ca0443d594e1930c36d20235/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Dirty Money The Rich Get Rich",
      "description": "Dirty Money: The Rich Get Rich is a money clicker relaxation game. You are permitted to make money by tapping. When you earn some money and level up on the corresponding level, you can speed up by upgrading in the Growth, using the Invest, and making the Assets. The more money you make, the more functions you can unlock and use. I hope you will complete the target and make 100 million!",
      "instructions": "Mouse click or tap to play",
      "genres": [
        "Casual"
      ],
      "tags": [
        "clicker"
      ]
    },
    "zh-CN": {
      "title": "污钱 富人更富",
      "description": "《脏钱：富人越富》是一款金钱点击放松游戏。您可以通过点击来赚钱。当您赚取一些金钱并在相应等级提升等级时，可以通过升级增长、使用投资和创造资产来加速。您赚的钱越多，可以解锁和使用的功能就越多。希望您能完成目标，赚到1亿！",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲"
      ],
      "tags": [
        "点卡器"
      ]
    },
    "zh-TW": {
      "title": "汙金 富者愈富",
      "description": "髒錢：富者愈富是一款錢點擊放鬆遊戲。你可以透過點擊來賺錢。當你賺到一些錢並在相應的等級升級時，你可以透過升級成長、投資和創造資產來加速。你賺的錢越多，你可以解鎖和使用的功能就越多。希望你能完成目標，賺到一億！",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "休閒"
      ],
      "tags": [
        "點擊器"
      ]
    },
    "zh-HK": {
      "title": "汙錢 富者越富",
      "description": "骯垢錢財：富者越富是一款錢幣點擊放鬆遊戲。你被允許通過點擊來賺錢。當你賺了一些錢並在相應等級升級時，你可以通過在成長、投資和創建資產中升級來加速。你賺越多錢，你就能解鎖和使用的功能就越多。希望你能完成目標，賺到一億元！",
      "instructions": "滑鼠點擊或輕觸開始遊戲",
      "genres": [
        "隨意"
      ],
      "tags": [
        "點擊器"
      ]
    },
    "ja": {
      "title": "ダーティー・マネー 財を積む者は富を得る",
      "description": "Dirty Money: The Rich Get Richは、マネyclickerリラックスゲームです。タップすることでお金を稼ぐことができます。お金を稼ぎ、対応するレベルでレベルアップすると、成長をアップグレードして、投資して、資産を作成することでスピードを速めることができます。もっとお金を稼いだら、もっと機能を解除して使用することができます。ターゲットを達成して1億ドルを目指してください！",
      "instructions": "マウスクリックまたはタップして遊ぶ",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "クリッカーサイト"
      ]
    },
    "ko": {
      "title": "DIRTY MONEY 부유한 사람들은 더 부유하게 된다.",
      "description": "DIRTY MONEY: THE RICH GET RICH은 돈 클릭 라쉬션 게임입니다. 탭하여 돈을 벌 수 있습니다. 돈을 벌고 해당 레벨에서 레벨업하면 Growth을 업그레이드하고, Invest를 사용하고, 자산을 만들어 속도를 빨리할 수 있습니다. 더 많은 돈을 벌면 더 많은 기능을 해금하고 사용할 수 있습니다. 목표를 달성하고 1억 달러를 만들어 보세요!",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "클릭러"
      ]
    },
    "fr": {
      "title": "Argent sale : les riches deviennent riches",
      "description": "Dirty Money: The Rich Get Rich est un jeu de relaxation de clics sur l'argent. Vous pouvez gagner de l'argent en tapant. Lorsque vous gagnez de l'argent et que vous montez de niveau sur le niveau correspondant, vous pouvez accélérer en mettant à niveau la Croissance, en utilisant l'Investir et en créant des Actifs. Plus d'argent vous gagnez, plus de fonctions vous pouvez débloquer et utiliser. J'espère que vous atteindrez votre objectif et ferez 100 millions !",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Casual"
      ],
      "tags": [
        "cliqueur"
      ]
    }
  }
};
